import { useAppSelector } from 'redux/store/store.types';

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';

function withRoot(Component) {
  function WithRoot(props) {
    const { brandingSettings } = useAppSelector((state) => state.platform);

    const textColors = {
      primary: brandingSettings.accent_color,
      secondary: brandingSettings?.accent_text_color || '#000000',
    };

    const theme = createTheme({
      props: {
        MuiSvgIcon: {
          htmlColor: '#fff',
        },
      },
      palette: {
        type: 'dark',
        primary: {
          main: textColors.primary,
        },
        secondary: {
          main: textColors.secondary,
        },
        background: {
          primary: '#2F2F2F',
          light: '#454545',
          dark: '#2a2a2a',
        },
      },
      typography: {
        color: '#fff',
        fontFamily: `Roboto, sans-serif`,
        button: {
          textTransform: 'none',
        },
        fontSize: 14,
      },
      overrides: {
        MuiButton: {
          outlined: {
            borderColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .23)`,
          },
          root: {
            color: '#fff',
            borderColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .23)`,
            '&:hover': {
              borderColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .50)`,
              color: '#ffffff',
            },
          },
        },
        MuiOutlinedInput: {
          root: {
            '& .Mui-disabled': {
              outlineColor: '#757575',
              borderColor: '#757575',
            },
            '&:disabled': {
              color: 'rgba(0, 0, 0, 0.75)',
              outlineColor: '#757575',
              borderColor: '#757575',
            },
            color: '#fff',
            '& label': {
              color: '#fff',
            },
            '& fieldset': {
              color: '#fff',
              outlineColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .23)`,
              borderColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .23)`,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              outlineColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .5)`,
              borderColor: `rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .5)`,
            },
          },
        },
        MuiInputLabel: {
          root: {
            color: '#fff',
          },
        },
        MuiFormHelperText: {
          root: {
            color: textColors.primary,
          },
        },
        MuiFilledInput: {
          root: {
            borderColor: 'brown',
            color: '#fff',
            '& label': {
              color: textColors.primary,
            },
          },

          underline: {
            '&:hover': {
              '&:before': {
                borderBottom: `1px solid rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .23)`,
              },
            },
            '&:before': {
              borderBottom: `1px solid rgba(${brandingSettings.accentColorRGB.r}, ${brandingSettings.accentColorRGB.g}, ${brandingSettings.accentColorRGB.b}, .23)`,
            },
          },
        },
        MuiInput: {
          root: {
            color: '#fff',
          },
          underline: {
            '&:before': {
              borderBottom: '2px solid #fff',
            },
            '&:hover:not(.Mui-disabled)': {
              '&:before': {
                borderBottom: '2px solid #fff',
              },
            },
            '&.Mui-disabled:before': {
              borderBottom: '2px solid transparent',
            },
          },
        },
        MuiAppBar: {
          root: {
            backgroundColor: '#ffffff',
          },
        },
        MuiSlider: {
          markLabel: {
            color: '#fff',
            fontSize: '.75rem',
          },
          markLabelActive: {
            color: 'currentColor',
          },
        },
        MuiSwitch: {
          track: {
            opacity: ' 0.5 !important',
          },
        },
      },
    });

    return (
      <MuiThemeProvider theme={theme}>
        <Component {...props} />
      </MuiThemeProvider>
    );
  }

  return WithRoot;
}

export default withRoot;
